import { connect } from 'react-redux';
import { useWindowSize } from "../../../hooks/useWindowSize";
// import { DatePickerField } from "../../../shared/_helpers/datepicker";

import "react-datepicker/dist/react-datepicker.css";
import { InAppTemplate } from "../../../shared/templates/inapp";
import { storeActions } from "../../../redux/actions/in-app"

// import "../index.scss"
import "../../../scss/orders.scss";


import { InAppContent } from '../../../views/Inapp/orders/InAppContent';


const OrderList = (pageProps: any) => {
    const screenResolution: any = useWindowSize();
    return (
        <InAppTemplate isWide={screenResolution?.width <= 1024 ?true:false} pageHeadingTitle="My Orders" childComponent={<InAppContent pageProps={pageProps} />} />
    )
}

const mapDispatchToProps = {
    getStoreOrders: storeActions.GetStoreOrders,
    getStoreOrderDetails: storeActions.GetStoreOrderDetails,
    changeOrderStatus: storeActions.ChangeOrderStatus,
};

const mapStateToProps = (state: any) => ({
    // return {
    getStoreOrdersRequest: state.allProductReducers.getStoreOrderReducer,
    getStoreOrderDetailsRequest: state.allProductReducers.getStoreOrderDetailsReducer,
    changeOrderStatusRequest: state.allProductReducers.changeOrderStatusReducer,
    // };
})
export default connect(mapStateToProps, mapDispatchToProps)(OrderList);